interface ICompare {
  changedValues: any[],
  addedValues: any[],
  removedValues: any[],
}

export const compareArrays = (arr1: any[], arr2: any[]): ICompare => {
  const result = {
    changedValues: [],
    addedValues: [],
    removedValues: []
  };

  // Find changed or removed values (from arr1 to arr2)
  arr1.forEach((value, index) => {
    if (index < arr2.length) {
      // Check if the value has changed
      if (value !== arr2[index]) {
        result.changedValues.push({ index, oldValue: value, newValue: arr2[index] });
      }
    } else {
      // If arr2 has fewer elements, the rest of arr1 values are "removed"
      result.removedValues.push({ index, removedValue: value });
    }
  });

  // Find added values (in arr2 but not in arr1)
  if (arr2.length > arr1.length) {
    arr2.slice(arr1.length).forEach((value, index) => {
      result.addedValues.push({ index: arr1.length + index, addedValue: value });
    });
  }

  return result;
}

export const moveValueToFront = (array: string[], valueToMove: string) => {
  const filteredArray = array.filter(item => item !== valueToMove); // Remove the value
  return [valueToMove, ...filteredArray]; // Add the value to the beginning
}
